module.exports = __webpack_public_path__ + "static/assets/59c535227d8831801967f96a7537817c.png";